import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/multimedia'

const service = {
  byUrl(params) {
    const query = `/byUrl?isthumb=${params.isthumb}&url=${params.url}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findBySeccion(params) {
    const query = `/bySeccion?idEmpresa=${params.idEmpresa}&seccion=${params.seccion}&idSeccion=${params.idSeccion}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const formData = new FormData()
    formData.append('idEmpresa', 3)

    formData.append('idMultimedia', 0)
    formData.append('idSeccion', 1)
    formData.append('idx', 1)
    formData.append('orientacion', 'H')
    formData.append('seccionMult', 'DESTINOBANNER')
    formData.append('orientacion', 'H')
    formData.append('archivo', model)
    return new Promise((resolve, reject) => {
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  sort(params) {
    const query = `/sort?${params.multimedias}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
